import { render, staticRenderFns } from "./site.vue?vue&type=template&id=0b5ccb7c&"
import script from "./site.vue?vue&type=script&lang=ts&"
export * from "./site.vue?vue&type=script&lang=ts&"
import style0 from "./site.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports